export default __webpack_public_path__ + "static/media/ticket.fcd81783.svg";